"use strict";

const FactSheetNew = require("../general/factSheetNew");
const StructuralBmpFactSheetController = require("../bmpfcs/structuralBmpFactSheetController");

const MuniBmpFactSheetController = function () {
  const routeName = "muni-bmp-fact-sheet";

  const muniBmpFactSheetRoute = {
    as: routeName,
    handler: function ({ data, hashString }) {
      open(data.id, { highlightId: hashString });
    },
  };

  const muniBmpFactSheetHighlightRoute = {
    as: `${routeName}-highlight`,
    handler: muniBmpFactSheetRoute.handler,
  };

  var getConfig = function () {
    return {
      ...StructuralBmpFactSheetController.getConfig(),
      closeUrl: UrlRoutes.getDefaultUrl(),
      prepareDataFunction: prepareData,
    };
  };

  var prepareData = function (data) {
    StructuralBmpFactSheetController.prepareData(data);

    data.showRoutineMaintenanceButton = data.permissions?.canCreateRoutineInspection;
    data.showAddNewBenchmarkButton = false;
    data.showEditBenchmarkButton = false;
    data.showAddSbmpAssessmentButton = false;
  };

  var open = async function (id, options = {}) {
    FactSheetNew.open(id, getConfig(), null, options);
  };

  return {
    open,
    routeName,
    muniBmpFactSheetRoute,
    muniBmpFactSheetHighlightRoute,
    prepareData,
  };
};

module.exports = MuniBmpFactSheetController();

const UrlRoutes = require("../routes/urlRoutes");
